import { render, staticRenderFns } from "./ZitadelLoginModule.vue?vue&type=template&id=b91eea8a&scoped=true&"
import script from "./ZitadelLoginModule.vue?vue&type=script&lang=js&"
export * from "./ZitadelLoginModule.vue?vue&type=script&lang=js&"
import style0 from "./ZitadelLoginModule.vue?vue&type=style&index=0&id=b91eea8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91eea8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
